import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bfqoqeul: FaireBrandEntity = {
  token: "b_bfqoqeul",
  type: "brand",
  name: "Tiny Human Supply Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/995f292bba128e1ebebca460be9437e9e07f80567a744a737d2365dae087daee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2d53f67e3a695116e0d05bc2332547f2109520a28a58565be090a9b8bc6fc55.png",
  logoUrl:
    "https://cdn.faire.com/fastly/995f292bba128e1ebebca460be9437e9e07f80567a744a737d2365dae087daee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2d53f67e3a695116e0d05bc2332547f2109520a28a58565be090a9b8bc6fc55.png",
  location: "Raleigh, NC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 65,
  isInsider: true,
  description:
    "Clean Skincare that Celebrates the Messy Business of Babies 🖤\n\nWe're real people who left behind two corporate careers to build something new, for parents like us. From the miraculous to the monotonous and especially the messy, we wanted to create a brand that celebrated all the wonderful, yet exceptionally challenging experiences parents encounter every day in the land of tiny humanhood. Frankly, we could use a little humor to get through it all, because being a parent is the best, hardest job in the world. \n\nOur products are made in USA with plant-based ingredients and high organic content. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:25.217Z",
    importedBy: "entity-db-cli",
  },
};
